/*
 * Copyright (c) 2020 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import * as React from 'react';
import { Component } from "react";
import { Progress } from "@scuf/common";
import {
  IGatewayRegistrationProps, IRegistrationDetails, ISiteDetails
} from "../../../stores/GatewayManager/IGatewayRegistrationInterfaces";
import { inject, observer } from "mobx-react";
import './RegistrationProgress.scss';

/**
 * The state of the site registration
 */
export interface ISiteRegistrationProgressState {
  /**
   * Check the status of the registration progress
   */
  inProgress: boolean;
}

/**
 * Show the progress window for the Site registration process in background
 */
@observer
@inject('gatewayRegistrationStore')
export default class RegistrationProgress extends Component<IGatewayRegistrationProps, ISiteRegistrationProgressState> {

  /**
   * Constructor injection of IGatewayRegistrationProps
   * @param props
   */
  constructor(props: IGatewayRegistrationProps) {
    super(props);
    this.state = {
      inProgress: true
    };
  }

  /**
   * Perform gateway registration by mapping the site to gateway
   */
  componentDidMount() {

    // If enrollment id exists, assume it is to be registered using it
    let isFreshRegistration = !!this.props.enrollmentId;
    let deviceDetails = {
      epName: this.props.epName,
      serialNumber: this.props.serialNumber,
    } as IRegistrationDetails;

    this.processRegistrationRequest(isFreshRegistration, deviceDetails);


  }


  /**
   * Render the progress window
   */
  render() {
    return [
      <div className='application-page-content-no-nav ui-gw-reg-container'>
        <div className='ui-gw-reg-title'>
          {RegistrationProgress.TITLE}
        </div>
        <div className='ui-reg-progress-block'>
          {
            (this.state.inProgress) ? <Progress circular={true}
              size={"xlarge"}
              className='ui-gw-reg-progress' /> :
              <></>
          }
        </div>
      </div>
    ]
  }

  processRegistrationRequest = async (isFreshRegistration: any, deviceDetails: any) => {
    let gatewayRegistrationStore = this.props.gatewayRegistrationStore;
    let registrationProgress;
    let siteDetails = this.props.siteDetails;
    gatewayRegistrationStore!.getCustomerDetails(siteDetails.siteId).then((response) => {
      //Populate SiteName and CustomerName for SiteID if missing
      if (response && response.status == 200 && response.data) {
        this.populateCustomerDetails(siteDetails, response.data);
      }
      if (isFreshRegistration) {
        deviceDetails['enrollmentId'] = this.props.enrollmentId;
        registrationProgress = gatewayRegistrationStore!.registerGatewayByEnrollmentId(deviceDetails, this.props.siteDetails);
      } else {
        deviceDetails['deviceId'] = this.props.deviceId;
        registrationProgress = gatewayRegistrationStore!.registerGatewayByDeviceId(deviceDetails, this.props.siteDetails);
      }
      registrationProgress && registrationProgress.then((response) => {
        // 200 for the registration using device id and 201 for the enrollment id based
        // For device id based site association, it is a PUT call and hence status code is 200
        // For enrollment id based registration, it is a POST call and the status code is 201
        if ((isFreshRegistration && response.status === 201) || response.status === 200) {
          this.props.gatewayRegistrationSuccess!();
        } else {
          this.props.gatewayRegistrationFailed!(response.status);
        }
      }).catch(error => {
        let status = -1;
        if (error && error.response && error.response.status) {
          status = error.response.status;
        }
        this.props.gatewayRegistrationFailed!(status);
      }).finally(() => {
        this.setState({
          inProgress: false
        });
      });
    })
  }

  populateCustomerDetails = (siteDetails: ISiteDetails, customerDetails: any) => {
    if (customerDetails && customerDetails.data) {
      if (customerDetails.data['customerName']) {
        siteDetails.customerDetails.organizationName = customerDetails.data['customerName'];
      }
      if (customerDetails.data['siteName']) {
        siteDetails.siteName = customerDetails.data['siteName'];
      }
    }
  }

  public static readonly TITLE = 'Registering Gateway';
}
